module.exports = __webpack_public_path__ + "static/img/20009 (1).200ad62.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20009 (1).webp
// module id = Kh4N
// module chunks = 14